<app-stepper-form
  header="Bulk Cessation of Officeholder"
  formIcon="ic-cessation-of-officeholder-20"
  [showSteps]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading()"
  [form]="stepperForm"
  [isInvalid]="areAllRowsHaveErrors"
  (stepIndexChange)="onStepChange($event)"
>
  <div
    class="step-content"
    [class]="{'step-content-error': (currentStep === StepsEnum.Summary && isGridIncludesError)}"
    [formGroup]="stepperForm"
  >
    <app-stepper-form-description
      formKey="484 B1"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [hidden]="currentStep !== StepsEnum.CeaseCompanyOfficeholder"
      [formGroupName]="StepsEnum.CeaseCompanyOfficeholder"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          class="flex-grow-1"
          label="Date of Cessation"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      @if (lateFeeMessage) {
        <app-disclaimer
          color="red"
          icon="ic-info-circle-20"
        >
          {{ lateFeeMessage }}
        </app-disclaimer>
      }

      <div class="form-group">
        <app-select
          label="Cease Officer"
          formControlName="appointedOfficerId"
          [options]="commonOfficeholdersSelectOptions"
          [valuePrimitive]="true"
          (select)="onOfficeholderChange($event?.value)"
        />
      </div>

      @if (this.form.controls.appointedOfficerId.value !== null) {
        <div class="form-group">
          <app-checkbox-group
            label="Positions"
            formControlName="types"
            [options]="commonOfficeholdersAvailablePositionsOptions"
          />
        </div>
      }

      <div class="form-group">
        <app-select
          label="Reason"
          formControlName="cessationReason"
          [options]="reasonOfCessationOptions"
          [valuePrimitive]="true"
        />
      </div>

      <div class="form-group" [hidden]="noticeOfResignationHidden">
        <app-textarea
          label="Notice of Resignation"
          formControlName="noticeOfResignation"
          [rows]="3"
        />
      </div>

      <div class="form-group">
        <app-radio
          formControlName="documentationType"
          label="Choose the type of document to generate"
          [options]="documentTypeOptions"
        />
      </div>
    </section>

    <section
      class="step-section gap-32"
      [formGroup]="form"
      [hidden]="currentStep !== StepsEnum.Summary"
    >
      <h1 class="h1-heading">Change is applied for</h1>

      @if (colDefs.length) {
        <div class="mw-100 w-100">
          <app-list-grid-client-side
            class="bulk-change-grid"
            [rowData]="rows"
            [colDefs]="colDefs"
            [rowSelection]="rowSelection"
            [rowClassRules]="rowClassRules"
            [suppressRowClickSelection]="true"
            [paginationPageSizeSelector]="false"
            [suppressCellFocus]="true"
          />
        </div>
      }
    </section>
  </div>
</app-stepper-form>


